import { createAction, props } from '@ngrx/store';
import {
  AgGridColumnFilter,
  AgGridColumnSort,
  AgGridResponseOfMaintenanceDto,
  MaintenanceCounterDto,
  MaintenanceDto,
  PagedMaintenanceDto,
} from '@services/api/api.service';
import { Sort } from '@angular/material/sort';
import { PagedResponseOfOnboardedVehicleDto } from '@services/api/sdf-agrirouter-api.service';

export const setMaintenancesLoading = createAction(
  'setMaintenancesLoading',
  props<{ isLoading: boolean }>(),
);

export const setMaintenancesFilters = createAction(
  'setMaintenancesFilters',
  props<{ filters: { qSearch?: string, sortModel?: AgGridColumnSort[], filterModel?: { [key: string]: any; } } }>(),
);

export const setMaintenancesPaginator = createAction(
  'setMaintenancesPaginator',
  props<{ paginator: { page: number, pageSize: number } }>(),
);

export const setMaintenancesList = createAction(
  'setMaintenancesList',
  props<{ response: PagedMaintenanceDto }>(),
);

export const getMaintenancesList = createAction(
  'getMaintenancesList',
);

export const getMaintenancesCounters = createAction(
  'getMaintenancesCounters',
);

export const setMaintenanceSummary = createAction(
  'setMaintenanceSummary',
  props<{
    value: MaintenanceCounterDto
  }>(),
);

export const setMaintenanceLoading = createAction(
  'setMaintenanceLoading',
  props<{ value: boolean }>(),
);
export const setMaintenanceFilters = createAction(
  'setMaintenanceFilters',
  props<{ filters: any }>(),
);
export const getMaintenanceList = createAction(
  'getMaintenanceList',
  props<{
    pageIndex: number;
    pageSize: number;
    sort?: Sort;
  }>(),
);

export const getMaintenanceSummary = createAction(
  'getMaintenanceSummary',
);

export const setMaintenanceList = createAction(
  'setMaintenanceList',
  props<{
    vehicles: MaintenanceDto[],
    page: number,
    pageSize: number,
    totalNumber: number
  }>(),
);
